import React, { FC, useState } from 'react'
import { slugs } from '@/constants/slugs'
import { BasicCarousel } from '@/molecules/BasicCarousel'
import { useTranslate } from '@/utils/translate/translate-client'
import { HomesteadLightBox } from '@/views/PreSales/PreSalesGiveawayView/components/Tabs/PresaleDetailsTab/HomesteadLightbox'
import { GTitleMD, GTitleXL } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { GalleryImage } from '@/views/PreSales/PreSalesGiveawayView/config'

interface GalleryCarousel {
  galleryImages: GalleryImage[]
  theatricalSlug: string
}

export const GalleryCarousel: FC<GalleryCarousel> = ({ galleryImages, theatricalSlug }) => {
  const { t } = useTranslate('tickets')
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  const openLightbox = (index: number) => {
    setCurrentImageIndex(index)
    setIsLightboxOpen(true)
  }

  return (
    <section className="flex flex-col gap-4">
      <GTitleMD color="giveaway-text-primary-dark" className="uppercase">
        {theatricalSlug === slugs.youngWashington ? (
          <GTitleXL color="giveaway-text-primary-dark" className="mb-1">
            {t('conceptArtFromMovie', 'Concept Art From the Movie')}
          </GTitleXL>
        ) : (
          t('showImages', 'Show Images')
        )}
      </GTitleMD>
      <BasicCarousel showGradients containerClassName="!gap-2 !px-2">
        {galleryImages.map((image, index) => (
          <img
            key={image.src}
            src={image.src}
            alt={image.alt}
            className="w-72 rounded-lg"
            onClick={() => openLightbox(index)}
          />
        ))}
      </BasicCarousel>
      {isLightboxOpen && (
        <HomesteadLightBox
          showImages={galleryImages}
          currentImageIndex={currentImageIndex}
          setIsLightboxOpen={setIsLightboxOpen}
          setCurrentImageIndex={setCurrentImageIndex}
        />
      )}
    </section>
  )
}
